import {
  Box,
  Button,
  Code,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { API_ROUTES } from "utils/constant";
import { axiosPost } from "utils/api";

const BRAND_OPTIONS = ["8day", "2q", "888b", "test"];

function ApiKeyAddDialog({ isOpen, onClose, refetch }) {
  const [brand, setBrand] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [createdKey, setCreatedKey] = useState(null);
  const toast = useToast();

  async function handleSubmit() {
    if (!brand.trim()) {
      toast({
        title: "Vui lòng chọn brand",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    setLoading(true);
    try {
      const res = await axiosPost(API_ROUTES.ApiKeyCreate, {
        brand: brand.trim().toLowerCase(),
        note: note.trim() || undefined,
      });
      if (res?.data?.code !== 0) {
        toast({
          title: res?.data?.msg || "Tạo thất bại",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
        return;
      }
      setCreatedKey(res.data.data);
      toast({
        title: "Đã tạo API key — copy ngay (key sẽ không hiển thị lại sau khi đóng)",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      refetch?.();
    } catch (error) {
      toast({
        title: error?.response?.data?.msg || "Tạo thất bại",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  }

  function handleClose() {
    setBrand("");
    setNote("");
    setCreatedKey(null);
    onClose();
  }

  function handleCopy() {
    navigator.clipboard?.writeText(createdKey?.key || "");
    toast({
      title: "Đã copy",
      status: "success",
      duration: 2000,
      isClosable: true,
    });
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{createdKey ? "API Key đã tạo" : "Tạo API Key"}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {!createdKey ? (
            <>
              <FormControl mb="4">
                <FormLabel>Brand</FormLabel>
                <Select
                  placeholder="Chọn brand"
                  value={brand}
                  onChange={(e) => setBrand(e.target.value)}
                >
                  {BRAND_OPTIONS.map((b) => (
                    <option key={b} value={b}>
                      {b}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel>Ghi chú</FormLabel>
                <Input
                  placeholder="vd. IT 8day production, Yuri 2q test..."
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
              </FormControl>
            </>
          ) : (
            <Box>
              <Text mb="2" fontSize="sm">
                Brand: <b>{createdKey.brand}</b>
              </Text>
              <Text mb="2" fontSize="sm" color="red.500">
                Copy key NGAY — sẽ không hiển thị lại đầy đủ sau khi đóng dialog.
              </Text>
              <Code
                p="3"
                w="100%"
                wordBreak="break-all"
                fontFamily="mono"
                fontSize="sm"
              >
                {createdKey.key}
              </Code>
              <Button mt="3" size="sm" onClick={handleCopy} colorScheme="blue">
                Copy Key
              </Button>
            </Box>
          )}
        </ModalBody>
        <ModalFooter>
          {!createdKey ? (
            <>
              <Button variant="ghost" mr="3" onClick={handleClose}>
                Huỷ
              </Button>
              <Button
                colorScheme="green"
                onClick={handleSubmit}
                isLoading={loading}
              >
                Tạo
              </Button>
            </>
          ) : (
            <Button colorScheme="blue" onClick={handleClose}>
              Đóng
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default ApiKeyAddDialog;
